export const convertCurrency = (salary: number, currency: string): string => {
  return `${currency} ${new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(salary)}`;
};
